<template>
    <transition name="fade">
        <div class="alert__block" v-if="show">
            <div class="alert__block_header">
                <h3 class="h_text">{{ notification.title }}</h3>
                <div class="alert__block_close" @click="setNotificationToRead()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z"
                            fill="#000"/>
                    </svg>
                </div>
            </div>
            <pre v-html="notification.message"></pre>
        </div>
    </transition>

</template>

<script>
export default {
    name: "NotificationAlertBlock",
    props: {
        setnotificationlink: {
            type: [String]
        },
        notification: {
            type: [Object]
        },
    },
    methods: {
        setNotificationToRead() {
            axios.post(this.setnotificationlink, {
                notification_id: this.notification.id
            }).then(response => {
                if (response.status === 200) {
                    this.show = false
                }

            }).catch(error => {

            });
        }
    },
    data(){
        return {
            show:true
        }
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
    opacity: 0;
}
</style>
